import { Injectable, signal } from '@angular/core';
import { MasterdataCostCenter } from '@softapps/core/masterdata';

/** "Carry over to next position" state of the add-product form. */
@Injectable()
export class ItemPrefillService {
  readonly carryOverText = signal(false);
  readonly carryOverCostCenter = signal(false);
  readonly lastText = signal('');
  readonly lastCostCenter = signal<MasterdataCostCenter | null>(null);
}
